export interface Testimonial {
  id: string;
  name: string;
  role: string;
  text: string;
  initial: string;
}

export const testimonials: Testimonial[] = [
  {
    id: "tm-01",
    name: "林小满",
    role: "上班族 · 通勤党",
    text: "以前通勤路上得刷好几个地方才能拼出个大概，现在一条时间线顺着往下看就够了。早上八点那波更新最有用。",
    initial: "林",
  },
  {
    id: "tm-02",
    name: "阿哲",
    role: "夜猫子 · 内容爱好者",
    text: "喜欢它把每条快讯的可信度标出来。深夜刷到一些没法确认的说法，看标签就知道先别急着转发，这点很实在。",
    initial: "哲",
  },
  {
    id: "tm-03",
    name: "周周",
    role: "学生 · 追星族",
    text: "巡演和开票的提醒来得挺及时的，加场信息我是从时间线看到的，比群里消息还早一点。",
    initial: "周",
  },
  {
    id: "tm-04",
    name: "老郑",
    role: "从业者 · 关注行业动态",
    text: "深度专题那块做得不错，把一件事从最早露出到官方回应按步骤列清楚，看着不累，比零散爆料清楚多了。",
    initial: "郑",
  },
  {
    id: "tm-05",
    name: "小鹿",
    role: "自由职业 · 内容爱好者",
    text: "不注册也能看，这点很舒服。界面干净，没有那种一层层弹窗，点开就能读，速度也快。",
    initial: "鹿",
  },
  {
    id: "tm-06",
    name: "陈默",
    role: "编辑 · 资讯岗",
    text: "把城市生活这类内容单列出来挺好的，出行提醒、活动报名这些和吃瓜无关的事也一起照顾到了。",
    initial: "陈",
  },
];